import type { PinFutureContractFormValues } from "web_myplann/Goals/Hooks/usePinFutureContractForm";
import { FuturePortfolioTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const isLoanFutureType = (type: FuturePortfolioTypeEnum) =>
	type === FuturePortfolioTypeEnum.Mortgage ||
	type === FuturePortfolioTypeEnum.Loan;

export const getAmounts = (values: PinFutureContractFormValues) =>
	isLoanFutureType(values.type)
		? { oneTimeDeposit: values.loanAmount || null, monthlyAmount: null }
		: {
				oneTimeDeposit: values.lumpSum || null,
				monthlyAmount: values.monthly || null,
			};

export const getDefaultFutureContractStartDate = () => {
	const now = new Date();
	return new Date(now.getFullYear() + 1, now.getMonth(), 1);
};
